import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/guest.vue").then(m => m.default || m)),
  onboarding: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/onboarding.vue").then(m => m.default || m))
}